import { uniqueId } from 'lodash';
import { EditableUserInputtedRequirementData, EditableRequirement } from '../types';

export const createBlankRequirement = ({
  dataType,
  minMatch,
  maxMatch,
  searchCombo: { combinator, searchQueries } = { searchQueries: [] },
}: EditableUserInputtedRequirementData = {}): EditableRequirement => ({
  dataType,
  ...(minMatch && { minMatch }),
  ...(maxMatch && { maxMatch }),
  searchCombo: {
    combinator,
    searchQueries,
  },
  id: uniqueId(),
});
